import { DeliveryFeeFormValues } from "../components/forms";
import { DeliveryFeeListItem } from "../financial.types";

export const getInitialDeliveryFeeFormValues = (
  editableFee: DeliveryFeeListItem | null
): DeliveryFeeFormValues => {
  return {
    id: editableFee?.id,
    zoneId: editableFee?.deliveryZoneId,
    country: editableFee?.deliveryZone.country ?? null,
    city: editableFee?.deliveryZone.city ?? null,
    neighborhood: editableFee?.deliveryZone.neighborhood ?? null,
    sizeSFee: editableFee?.sizeSFee ? String(editableFee?.sizeSFee) : "",
    sizeMFee: editableFee?.sizeMFee ? String(editableFee?.sizeMFee) : "",
    sizeLFee: editableFee?.sizeLFee ? String(editableFee?.sizeLFee) : "",
    allowCashOnDelivery:
      editableFee !== null ? editableFee.allowCashOnDelivery : true,
    allowMobileMoney:
      editableFee !== null ? editableFee.allowMobileMoney : true,
    isExpedition:
      editableFee !== null ? editableFee.deliveryZone.isExpedition : false,
    isHiddenFromResellers:
      editableFee !== null
        ? editableFee.deliveryZone.isHiddenFromResellers
        : false,
    allowedResellerIds:
      editableFee?.deliveryZone.allowedResellers?.map(
        (reseller) => reseller.id
      ) ?? []
  };
};
